import {Inject, Pipe, PipeTransform} from '@angular/core';
import { Locale } from '@dash/randy/shared/classes/Locale';
import { COLLECTION_LOCALE } from '@dash/randy/tokens/collection-item-locale.token';

@Pipe({
    name: 'simpleLocale',
    standalone: false
})
export class LocaleSimplePipe implements PipeTransform {
  constructor(
    @Inject(COLLECTION_LOCALE) private collectionLocaleId: string,
  ) {}

  transform(value: Locale[], lang?: string): string {
    if (!value) {
      return ('Waiting for translation');
    }
    if (value.length === 0) {
      console.error(value, 'This value doenst have any records!');
      return 'No text found';
    }
    if (!lang) {
      lang = this.collectionLocaleId;
    }
    let localeObj = value.find(locale => locale.locale === lang);
    if (localeObj) {
      return localeObj.data;
    }
    console.warn(value, 'Locale "' + lang + '" isn\'t found!');
    return value[0].data;
  }
}
